<template>
    <div>
        <div style="width: 100%;margin-bottom: 60px;margin-top: 20px;">
            <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d500f6287f8.png" style="width: 100%;" alt="" @click="login">
        </div>
        <div class="newsBox">
            <div class="newsItem" v-for="item in list" @click="viewDetail(item.news_id)">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d501d0bf18b.png" style="width: 18em;margin-right: 40px;" alt="">
                <div class="newsInfo">
                    <div class="titles">{{item.title}}</div>
                    <div class="infos">{{item.organ}}</div>
                </div>
            </div>
        </div>
        <!-- <div v-if="textShow" @touchmove.stop="" @click="textShow = false" style="width: 100%;height: 100%;background: rgba(0,0,0,0.4);position: fixed;top: 0;left:0;display: flex;justify-content: center;flex-direction: column;align-items: center;">
            <div style="width: 60%;border-radius: 20px;box-shadow: 0 3px 10px 0 rgba(0,0,0,0.2);padding: 20px;background: #fff;">
                <div style="height: 500px;overflow: hidden;overflow-y: scroll;" v-html="text"></div>
            </div>
        </div> -->
    </div>
</template>
<script>
import axios from 'axios';
import { newList } from '@/api/modules/pagesApi'
    export default {
        name: 'News',
        data() {
            return {
				list: [],
                text: '',
                textShow: false
            }
        },
        methods: {
            viewDetail(id){
                        this.$router.push({name: "NewsInfo",query: {id: id}});
                // var that = this
                // axios.defaults.headers.common['APPKEY'] = 'official';
                // var query = {news_id: id}
                // axios.post('https://www.zhelihao123.com/user/member/news/detail',query)
                //     .then(response => {
                //         console.log('新闻详情='+JSON.stringify(response))
                //         that.text = response.data.data.desc
                //         that.textShow = true
                //     })
            },
            login(){
                window.open('https://llhsh.zhelihao123.com/admin/')
            },
            getInfo(){
				var that = this
                // newList().then(res=>{
                //     console.log('新闻='+JSON.stringify(res))
                // })
				axios.defaults.headers.common['APPKEY'] = 'official';
                var query = {}
                axios.post('https://www.zhelihao123.com/user/member/news/index',query)
                    .then(response => {
                        console.log('新闻='+JSON.stringify(response))
						that.list = response.data.data.data
                })
            }
        },
        mounted() {
            this.getInfo()
        },
        computed: {

        },
    }
</script>

<style scoped>
.newsBox{width: 90%;margin: 60px 0;margin-left: 5%;}
.newsItem{display: flex;align-items: center;padding: 20px 100px;box-sizing: border-box;}
.titles{color: #333;font-size: 1.8em;}
.infos{color: #333;font-size: 1.3em;margin-top: 15px;}
</style>